<template>
  <DxSelectBox
    :ref="dropDownBoxRefName"
    :drop-down-options="dropDownOptions"
    :data-source="dataSource"
    :value.sync="currentValue"
    display-expr="Description"
    value-expr="ItemCode"
    :search-expr="['ItemCode', 'Description']"
    search-mode="contains"
    :search-enabled="true"
    :on-item-click="onItemClicked"
    item-template="product-template"
    field-template="fieldSelect"
    @focus-in="focusIn"
    :disabled="disabled"
    :placeholder="''"
    :on-value-changed="onProductChanged"
    :show-clear-button="showClearButton"
    :readOnly="readOnly"
  >
    <template #product-template="{ data }">
      <div class="custom-auto-complete">
        <span class="auto-complete-primary">{{ data.Description }}</span>
        <span class="auto-complete-secondary">{{ data.ItemCode }}</span>
      </div>
    </template>
    <template #fieldSelect="{ data }">
      <div class="custom-auto-complete">
        <DxTextBox
          :value="data && data.Description"
          class="gc-grid-description"
          :readOnly="readOnly"
        />

        <span v-if="data" class="gc-grid-code">
          {{ data.ItemCode }}
        </span>
      </div>
    </template>
  </DxSelectBox>
</template>
<script>
import DxSelectBox from "devextreme-vue/select-box";

const dropDownBoxRefName = "dropDownBoxRef";

export default {
  components: {
    DxSelectBox,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onItemClick: {
      type: Function,
      default: () => function () {},
    },
    dataSource: {
      type: Array,
      default: () => {},
    },
    cellInfo: {
      type: Object,
      default: () => {},
    },
    focusIn: {
      type: Function,
      default: () => function () {},
    },
    onValueChanged: {
      type: Function,
      default: () => function () {},
    },
    showClearButton: {
      type: Boolean,
      default: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentValue: this.value,
      dropDownOptions: { width: 500 },
      dropDownBoxRefName,
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    onProductChanged(valueChangedArgs) {
      this.onValueChanged(valueChangedArgs, this.cellInfo);
    },
    onItemClicked(selectionChangedArgs) {
      this.currentValue = selectionChangedArgs.itemData.ItemCode;
      this.onItemClick(selectionChangedArgs, this.cellInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
.gc-dropdown-list-item {
  font-size: 14px;
}
</style>
